import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule, MatFormFieldAppearance } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { StateNotifyService } from '../../../../common/state/service/state-notify.service';
import { Subject, takeUntil } from 'rxjs';
import { TrailConditionService } from '../../service/trail-condition.service';
import { Trail } from '../../dto/trail';
import { TrailCondition } from '../../dto/trail-condition';

@Component({
  selector: 'dpi-trail-condition',
  imports: [FormsModule, MatFormFieldModule, MatInputModule, MatCardModule, MatIconModule, MatButtonModule,
    MatToolbarModule, MatSelectModule, MatTooltipModule, NgIf],
  templateUrl: './trail-condition.component.html',
  styleUrl: './trail-condition.component.scss'
})
export class TrailConditionComponent implements OnInit, OnDestroy {
  trail: Trail;
  trailCondition: TrailCondition = { id: 0, trial_id: 0 };
  isReadonly: boolean;
  fieldAppearance: MatFormFieldAppearance;
  destroyed$ = new Subject<void>(); // notifier of component being destroyed
  isContentChanged: boolean;

  constructor(
    private notifyService: StateNotifyService,
    private trailConditionService: TrailConditionService) {

    this.trail = this.notifyService.getSelectedTrail();
    this.isReadonly = true;
    this.isContentChanged = false;
    this.fieldAppearance = 'outline';
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.notifyService.trailSelection$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(model => {
        this.trail = model;
        this.reload(model.id);
      });

    this.notifyService.readonlyMode$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(res => {
        this.onEditModeChange(res);
      });
  }

  reload(trailId: number) {
    this.trailConditionService.getConditionByTrialId(trailId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: res => {
          if (res !== null) {
            this.trailCondition = res;
          } else {
            this.trailCondition = {
              id: 0, trial_id: this.trail.id, location: '', weather: '', sea_state: '', 
              water_depth: '', sea_current: '', limitations: '', remarks: ''
            };
          }
        },
        error: err => {
          console.log(err);
        }
      });
  }

  updateTrailCondition() {
    this.isContentChanged = false; // Reset the state, and disable the button to prevent multiple clicks
    this.trailConditionService.updateTrialCondition(this.trailCondition)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: model => {
          this.trailCondition = model;
        },
        error: err => { console.log(err); }
      });
  }

  onEditModeChange(isReadonly: boolean) {
    this.isReadonly = isReadonly;
    if (isReadonly) {
      this.fieldAppearance = 'outline';
    } else {
      this.fieldAppearance = 'fill';
    }
  }
  
  onContentChange() {
    this.isContentChanged = true;
  }

}
